<template>
	<div class="process process-bg">
		<div class="bg">
			<div class="title">
				<p style="height: 55px;"></p>
				<!-- <img style="width:188px" src="../../assets/image/match/process-title.png" alt=""> -->
			</div>
			<div class="process-line">
				<!-- <div class="top-box">
					<div class="box-text" style="color:rgb(177,177,177)">
						<div>征集期</div>
						<div>07.07-08.12</div>
					</div>
					<div class="box-text" style="margin-left:-40px;color:rgb(189,31,32)">
						<div>初评期</div>
						<div>07.07-08.12</div>
					</div>
					<div class="box-text" style="margin-right:55px">
						<div>复评期</div>
						<div>08.12</div>
					</div>
				</div>
				<div class="bottom-box">
						<div class="box-text">
								<div>总决赛</div>
								<div>07.07-08.12</div>
						</div>
						<div class="box-text" style="margin-right:20px">
								<div>颁奖展览</div>
								<div>08.12</div>
						</div>
				</div> -->
			</div>
  	</div>
  </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {

        };
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.process {
	width:100%;
	height: 1060px;
	// background: url('../../assets/image/match/process-bg.jpg') no-repeat center top;
	.bg {
		height: 100%;
		// background: url('../../assets/image/match/process-bg2.jpg') no-repeat center 217px;
	}
	.title {
		padding-top: 156px;
		text-align: center;
		margin-bottom: 40px;
	}

	.text {
		margin: auto;
		width: 580px;
		line-height: 50px;
		text-indent: 2em;
		font-size: 25px;
		color: rgb(31, 0, 2)
	}
}
.process-line {
	height: 1027px;
	background: url('../../assets/image/match/process-line2.png') no-repeat center top;
}
.top-box,
.bottom-box {
	display: flex;
	justify-content: space-between;
	width: 95%;
	font-weight:bold;
	margin:auto;
	color:black;
	.box-text{
		text-align:center;
		font-size:35px;
		margin-top:128px;
	}
}
.bottom-box{
    width:56%
}
</style>



// WEBPACK FOOTER //
// src/components/Match/process.vue